import React, { useState, useEffect, useContext, Fragment } from "react";
import * as moment from "moment";
import { useParams } from "react-router-dom";

import "./EditAddEmployee.css";
import MyReporteesImg from "assets/images/my-reportees.png";
import Context from "context/context";
import EmployeeAPI from "apis/panel/employee/employee";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Box from "@mui/material/Box";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Card from "@mui/material/Card";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";

const effectiveLimit = 10;

const MyReportees = () => {
  const { dispatch } = useContext(Context);
  let params = useParams();

  const { getEmployeeReporteesAPI } = EmployeeAPI();
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [reporteesData, setReporteesData] = useState([]);

  useEffect(() => {
    handleGetReportees();
  }, [offset]);

  const handleGetReportees = async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      const employeeId = params.id;
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
        managerId: employeeId,
      };
      let res = await getEmployeeReporteesAPI(values);
      console.log({ res });
      if (res?.data && res?.data?.reporteesData) {
        setReporteesData(res?.data?.reporteesData || []);
        setCount(res?.data?.count || 0);
      }
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (err) {
      console.log({ err });
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  return (
    <div>
      <Accordion sx={{ mt: 2, boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon className="Accordianicon" />}
          aria-controls="panel1-content"
          id="panel1-header"
          style={{
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
            height: "70px",
          }}
        >
          <Box sx={{ pl: 3 }}>
            {" "}
            <img
              sx={{ pl: 3 }}
              className="personalInfo-logo"
              src={MyReporteesImg}
              alt="info"
            />
          </Box>
          <Box className="acc-title" sx={{ pl: 3 }}>
            My Reportees
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          {/* {reporteesData?.length > 0 ? (
            <div className="reportees-main">
              {reporteesData?.map((e) => (
                <Card className="reportees-employee-card">
                    <p>{e.employeeName}</p>
                    <p>{e.designationName}</p>
                  <Card className="reportees-employee-subcard">
                    <div><MailOutlineIcon/> {e.employeeEmail}</div>
                  </Card>
                </Card>
              ))}
            </div>
          ) : (
            "No Data"
          )} */}
          {reporteesData?.length > 0 ? (
            <Fragment>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>S.No</TableCell>
                      <TableCell>Employee Name</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Designation</TableCell>
                      <TableCell>Date Of Joining</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reporteesData.map((row, index) => (
                      <TableRow
                        key={row.employeeName}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {index + 1 + (offset - 1) * 10}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.employeeName}
                        </TableCell>
                        <TableCell>{row.employeeEmail}</TableCell>
                        <TableCell>{row.designationName}</TableCell>
                        <TableCell>
                          {row.dateOfJoining
                            ? moment(row.dateOfJoining).format("DD-MMM-YYYY")
                            : ""}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Pagination
                  style={{ color: "#rgba(0, 112, 233, 1)" }}
                  page={offset}
                  count={
                    (count / effectiveLimit) % 10 == 0
                      ? Math.floor(count / effectiveLimit)
                      : Math.floor(count / effectiveLimit + 1)
                  }
                  onChange={(event, value) => {
                    setOffset(value);
                  }}
                />
              </Box>
            </Fragment>
          ) : (
            <div style={{ textAlign: "center", padding: "20px" }}>
              No Reportees Found.
            </div>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default MyReportees;
